import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { FieldConfigurationType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  AnyDescriptor,
  ConditionField,
  CustomColumnField,
  DimensionDescriptor,
  DimensionField,
  ListConfiguration,
  ListGeneralSettings,
  ReportField,
  SortField,
} from "../../../../../../../../api/types/svTypes.ts";
import {
  AreaItemType,
  DimensionFieldType,
  ItemDataType,
  MeasureUsage,
  MetaItemType,
} from "../../../../../../../../api/types/svTypes.ts";
import { createTabularField } from "../../common/utilities/createFields.ts";

const toListFieldConfiguration = (config: FieldConfiguration): FieldConfiguration => {
  const result = { ...config };
  delete result.grouping;
  return result;
};

export const createListField = (meta: AnyDescriptor): ReportField => {
  const field = createTabularField(meta);
  field.config = toListFieldConfiguration(field.config);
  return field;
};

export const createListReportConfiguration = (
  conditions: ConditionField[],
  fields: ReportField[],
  sorts: SortField[],
  settings: ListGeneralSettings,
  ledger?: string
): ListConfiguration => {
  return {
    ...(ledger ? { ledger } : {}),
    conditions: conditions.map((c) => c.config),
    fields: fields.map((field) => toListFieldConfiguration(field.config)),
    sort: sorts.map((s) => ({
      name: s.config.name,
      id: s.config.id,
      ordering: s.config.ordering,
      caption: s.config.caption,
      isGroupField: s.config.isGroupField,
      type: s.config.type,
    })),
    settings: { ...settings },
  };
};

export const configurationToListFields = (
  configs: FieldConfiguration[],
  dimensions: DimensionDescriptor[]
): ReportField[] => {
  return configs
    .map((config) => {
      const listConfig = toListFieldConfiguration(config);
      if (config.type === FieldConfigurationType.Custom) {
        return <CustomColumnField>{
          type: DimensionFieldType.CUSTOM,
          meta: {
            caption: config.name,
            type: ItemDataType.Numeric,
            name: config.name,
            itemType: MetaItemType.CUSTOM,
            usage: MeasureUsage.General,
            group: "",
          },
          areaItemType: AreaItemType.FIELDS,
          config: listConfig,
        };
      }
      if (config.type !== FieldConfigurationType.Dimension && config.type !== FieldConfigurationType.Aggregation) {
        return undefined;
      }
      const dimensionMeta = dimensions.find((d) => d.name === config.name);
      if (!dimensionMeta) {
        //eslint-disable-next-line no-console
        console.log(`Field ${config.name} is not found in the dimensions' list`);
        return undefined;
      }
      return <DimensionField>{
        type: DimensionFieldType.DIMENSION,
        meta: dimensionMeta,
        config: listConfig,
        areaItemType: AreaItemType.FIELDS,
      };
    })
    .filter((field): field is DimensionField | CustomColumnField => !!field);
};
